const processSsoViewTemplate = `
<a class="menu-item-link sso-link" ng-click="navigateToken(getToken)" tabIndex="0">
  <!-- The next two pieces check if it is an image.
  If the customText is, it displays the image.
  Else it displays the text -->
  <span ng-if="!isImg()">{{customText}}</span>
  <img ng-if="isImg()" ng-src="{{customText}}" />
  <!-- This form is used by the navigateToken function to
  submit the SSO request -->
  <form class="hide" id="SAMLFORM{{uniqueId}}" method="post" target="_blank"></form>
</a>
`;
export default processSsoViewTemplate;
